import DefaultLayout from './Default'

export default DefaultLayout
